import { useSelector } from "react-redux"
import { useQuery } from "@tanstack/react-query"

import { API_PAYMENT_TOOLS_URL } from "../constants"
import { IErrorResponse, PaymentToolType, IPaymentTool } from "../interface"
import { RootState } from "../../store/store"
import { checkIsFailure } from "../utils/utils"
import { axios } from "../axios"

export async function fetch(
  token: string | null,
  paymentToolType: PaymentToolType
) {
  const response = await axios.get(`${API_PAYMENT_TOOLS_URL}/default?paymentToolType=${paymentToolType}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })

  if (response.status === 204) {
    return null
  }

  if (checkIsFailure(response.status)) {
    throw new Error("Ошибка")
  }

  return response.data
}

export const useGetDefaultPaymentTool = (paymentToolType: PaymentToolType) => {
  const token = useSelector((state: RootState) => state.auth.token)

  const { data } = useQuery<IPaymentTool, IErrorResponse>({
    queryKey: ["default-payment-tool", paymentToolType],
    queryFn: () => fetch(token, paymentToolType),
    refetchInterval: false,
    refetchOnWindowFocus: false,
  })

  return {
    data,
  }
}
